import { ICON_BASE_URL } from 'components/routes/search/constants'

export function translateSearchData (formData, orderBy) {
  const defaultMax = 3218688
  let toMetersMultiplier = 1000

  if (formData.unit === 'mi') {
    toMetersMultiplier = 1 / 0.00062137
  }

  const translatedMinDistance = formData.distanceMinimum * toMetersMultiplier
  const translatedMaxDistance = formData.distanceMaximum * toMetersMultiplier

  const searchParams = {
    search_radius: formData.radius,
    minimum_distance: translatedMinDistance,
    maximum_distance:
      formData.distanceType === 'atleast' ?
      defaultMax :
      translatedMaxDistance,
    order_by: orderBy,
    text_search: formData.routeName,
    activity_type: formData.activityType,
    close_to_location: formData.location,
    limit: 20,
  }

  // Redux form will only have the prop on the obj if the checkbox is checked
  if (formData.hasOwnProperty('mobileOnly')) {
    searchParams.is_mobile = 1
  }

  return searchParams
}

export function getMapMarkers (routes) {
  return routes.map((route, i) => {
    const { coordinates } = route.starting_location
    return {
      id: route._links.self[0].id,
      icon: `${ICON_BASE_URL}/default_color/${i + 1}.png`,
      position: {
        lat: coordinates[1],
        lng: coordinates[0],
      },
    }
  })
}

export function updateMapMarkers (markers, selectedId) {
  return markers.map((marker, i) => {
    if (marker.id === selectedId) {
      marker.icon = `${ICON_BASE_URL}/selected_color/${i + 1}.png`
    } else {
      // Reset any previously selected icons
      marker.icon = `${ICON_BASE_URL}/default_color/${i + 1}.png`
    }

    return marker
  })
}

export function getPageLinks (linkObj) {
  const pageLinks = {
    next: null,
    prev: null,
  }

  if (linkObj.hasOwnProperty('next')) {
    pageLinks.next = linkObj.next[0].href
  }

  if (linkObj.hasOwnProperty('prev')) {
    pageLinks.prev = linkObj.prev[0].href
  }

  return pageLinks
}



// WEBPACK FOOTER //
// ./src/services/routes/helpers.js